export const carrierPickupLocationMessage = (
  settings
) => `If you are not likely to be at the shipping address to sign for
  your delivery, you can have your package delivered to a
  ${settings.data.shipCompliant.carrierForPickupLocations} or retail
  location near you.`;
